import { render, staticRenderFns } from "./control1Result.vue?vue&type=template&id=62856fcd&scoped=true&"
import script from "./control1Result.vue?vue&type=script&lang=js&"
export * from "./control1Result.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62856fcd",
  null
  
)

export default component.exports